{
  "version": "2.5.38",
  "commitHash": "78eadef23b50084e75c053bad5ab1b88f8136412",
  "commitShortHash": "78eadef2",
  "branchName": "fix-18205-product-metric-depots",
  "commitDate": "2026-10-27T15:22:21+01:00"
}
